<div class="shadow-full w-full flex flex-row justify-between items-center h-[72px] shrink-0 px-6 py-3.5 gap-4">

  <div class="flex flex-row justify-start items-center gap-2 h-10">
    <span class="font-medium text-lg">chatBIC</span>
  </div>

  <div class="flex flex-row justify-end items-center gap-4">
    <bic-button
      (onClick)="openNewChat()"

      buttonType="white"

      class="flex h-[38px] justify-center items-center gap-2 text-sm whitespace-nowrap">
      Neuer Chat
      <fa-icon [icon]="faPlus" iconLeft></fa-icon>
    </bic-button>

    <bic-button
      (onClick)="this.chatService.chatHistoryExpanded=!this.chatService.chatHistoryExpanded; this.chatService.allFilesExpanded=false"
      buttonType="white"
      class="flex h-[38px] justify-center items-center gap-2 text-sm whitespace-nowrap">
      Alle Chats
      <fa-icon [icon]="faMessages" iconLeft></fa-icon>
    </bic-button>
  </div>
</div>
